module.exports = __webpack_public_path__ + "img/b61.fefbbb5d.jpg";